<template>
    <div class="layout-inventory">
        <div class="inventory-header">
            <ul>
                <li @click="onTabStatus(0)" :class="tabStatus === 0?'active':''">备件统计</li>
                <li @click="onTabStatus(1)" :class="tabStatus === 1?'active':''">备件台账</li>
            </ul>
        </div>
        <div class="inventory-content">
            <!--s: 备件统计-->
            <div class="content" v-if="tabStatus === 0">
                <div class="inventory-select">
                    <div class="box">
                        <div class="box-list">
                            查找：<Input v-model="inventoryParams.name" clearable @on-clear="onSearch" prefix="ios-search-outline" placeholder="备件名称、备件型号、生产厂家" style="width: 300px" />
                        </div>
<!--                        <div class="box-button">-->
<!--                          <Button @click="onReset">重置</Button>-->
<!--                          <Button type="primary" @click="onSearch">查询</Button>-->
<!--                        </div>-->
                    </div>
                    <div class="box-btn">
                        <Button type="primary" icon="ios-add" @click="onAddList" class="right">新增</Button>
                    </div>
                </div>
                <div class="table">
                    <Table ref="selection" :height="deviceListHeight" :columns="partsColumns" :data="partsArray.content" >
                        <template slot-scope="{ index }" slot="序号">
                          {{ index+1 }}
                        </template>
                        <template slot-scope="{ row }" slot="备件信息">
                            <div class="table-info">
                                <img v-if="row.fileUrl" :src="row.fileUrl" class="image"/>
                                <div class="image-error" v-if="!row.fileUrl">
                                    <div class="box">
                                        <span class="table-image"></span>
                                    </div>
                                </div>
                                <div class="device-text">
                                    <div class="box">
                                        <span class="name">{{ row.name }}</span>
                                        <!--                                <span class="type">{{ row.classificationName }}</span>-->
                                        <div class="info">
                                            <span class="text">设备型号：{{ row.equipmentModelName || '无' }}</span>
                                            <span class="text">生产厂家：{{ row.equipmentManufacturerName || '无'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="库存数量">
                          {{ row.inventory }}{{ row.unit === '无'?'': row.unit}}
                        </template>
                        <template slot-scope="{ row }" slot="存放地点">
                          {{ row.equipmentWarehouseName || '/' }}
                        </template>
                        <template slot-scope="{ row }" slot="安装位置">
                            {{ row.positions.length === 0?'/':'' }}
                            <div class="location-box" v-if="row.positions.length!==0">
                                <ul>
                                    <li :key="key" v-for="(positions,key) in row.positions">{{ positions }}</li>
                                </ul>
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="操作">
                            <Tooltip content="修改" placement="top">
                                <a class="btn blue" href="javascript:" @click="onEditInventory(row)"><Icon type="ios-create" :size="22"/></a>
                            </Tooltip>
                            <Tooltip content="删除" placement="top">
                                <a class="btn" href="javascript:" @click="onDelInventory(row.id)"><Icon type="ios-trash" :size="22"/></a>
                            </Tooltip>
                        </template>
                        <template slot-scope="{ row,index }" slot="移动排序">
                          <a href="javascript:" v-if="(index+1)!==1" @click="onSortableFault(row.id,1)"><Icon type="ios-arrow-round-up" :size="22"/></a>
                          <a href="javascript:" v-if="(index+1)!==partsArray.content.length" @click="onSortableFault(row.id,2)"><Icon type="ios-arrow-round-down" :size="22"/></a>
                          <a href="javascript:" v-if="(index+1)!==1" @click="onSortableFault(row.id,3)">置顶</a>
                          {{ index === 0 && partsArray.content.length === 1?'/':'' }}
                        </template>
                    </Table>
                </div>
                <div class="device-list-page" v-if="partsArray.content && partsArray.content.length !== 0">
                    <Page :total="partsArray.totalSize" :current="inventoryParams.currentPage" show-total show-sizer size="small" :page-size="inventoryParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
                </div>
            </div>
            <!--e: 备件统计-->
            <!--s: 备件台账-->
             <div class="content" v-if="tabStatus === 1">
                 <div class="inventory-select">
                     <div class="box">
                         <div class="box-list">
                             库存变化：
                             <Select v-model="ledgerParams.operationType" style="width:100px">
                                 <Option v-for="(item,key) in inventoryType" :value="item.label" :key="key">{{ item.value }}</Option>
                             </Select>
                         </div>
                         <div class="box-list" style="margin-left: 20px">
                             筛选时间段：
                             <DatePicker type="daterange" v-model="pickerValue" placement="bottom-end" placeholder="开始时间 - 结束时间" @on-change="onChangeDate" @on-clear="onClearDate" style="width: 224px" />
                         </div>
                         <div class="box-button">
                             <Button @click="onResetLedger">重置</Button>
                             <Button type="primary" @click="onSearchLedger">查询</Button>
                         </div>
                     </div>
                     <div class="box-btn">
                         <Dropdown trigger="click" transfer-class-name="box-record">
                             <Button type="primary" icon="ios-add"  class="right">新增</Button>
                             <template #list>
                                 <DropdownMenu>
                                     <DropdownItem><a href="javascript:" @click="onWarehousing">入库记录</a></DropdownItem>
                                     <DropdownItem><a href="javascript:" @click="onOutboundVisible">出库记录</a></DropdownItem>
                                 </DropdownMenu>
                             </template>
                         </Dropdown>
                     </div>
                 </div>
                 <div class="table">
                     <Table ref="selection" :row-class-name="rowClassName" :height="deviceListHeight" :columns="ledgerColumns" :data="ledgerArray.content" >
                         <template slot-scope="{ index }" slot="序号">
                             {{ index+1 }}
                         </template>
                         <template slot-scope="{ row }" slot="是否作废">
                             <font class="grey" v-if="row.status === 1">已作废</font>
                         </template>
                         <template slot-scope="{ row }" slot="备件名称">
                             {{ row.sparePartsName }}
                         </template>
                         <template slot-scope="{ row }" slot="填报日期">
                             {{ row.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0] }}
                         </template>
                         <template slot-scope="{ row }" slot="库存变动">
                             <font v-if=" row.operationType === 2" class="inbound red">出库</font>
                             <font v-if=" row.operationType === 1" class="inbound green">入库</font>
                         </template>
                         <template slot-scope="{ row }" slot="变动数量">
                             {{ row.num }}{{ row.unit === '无'?'': row.unit}}
                         </template>
                         <template slot-scope="{ row }" slot="填报人">
                             <span class="create-name"> {{ row.createUser }}</span>
                         </template>
                         <template slot-scope="{ row }" slot="记录说明">
                             {{ row.describes === '' || row.describes === '无'?'/':row.describes }}
                         </template>
                         <template slot-scope="{ row }" slot="操作">
                             <a v-if="row.sparePartsDel !== 1 && row.status === 1" class="btn blue" href="javascript:" @click="onLookRecord(row)" style="opacity: 1;color: #2d8cf0">查看详情</a>
                             <a v-if="row.sparePartsDel !== 1 && row.status === 0" class="btn blue" href="javascript:" @click="onEditRecord(row)">编辑</a>
                             <a v-if="row.sparePartsDel !== 1 && row.status === 0 && row.operationType === 2" class="btn blue" href="javascript:" @click="onVoid(row.id)">作废</a>
                             {{ row.sparePartsDel === 1?'/':'' }}
                         </template>
                     </Table>
                 </div>
                   <div class="device-list-page" v-if="ledgerArray.content && ledgerArray.content.length !== 0">
                       <Page :total="ledgerArray.totalSize" :current="ledgerParams.currentPage" show-total show-sizer size="small" :page-size="ledgerParams.displayNumber" @on-change="onSearchLedgerPage" @on-page-size-change="onSearchLedgerPageSize"/>
                   </div>
            </div>
            <!--e: 备件台账-->
        </div>

        <!--s: 编辑列表-->
        <Modal
            v-model="addInventoryVisible"
            :title="partsStatus?'编辑备件':'新增备件'"
            :width="!partsStatus?600:500"
            @on-visible-change="onVisibleChange"
            class-name="inventory-edit"
            footer-hide>
            <div class="inventory-edit-box">
<!--                <div class="record-header" v-if="!partsStatus">-->
<!--                    <div class="box"><Icon custom="info-icon"></Icon>仔细填写备件信息，提交后不可更改</div>-->
<!--                </div>-->
                <ul class="item-ul">
                    <li class="item">
                        <span class="label required">备件名：</span>
                        <Input v-model="editParams.name" :disabled="partsStatus" maxlength="25" show-word-limit placeholder="请输入"  style="width: 300px" />
                    </li>
                    <li class="item">
                        <span class="label">备件型号：</span>
                        <Select v-model="editParams.equipmentModelId" :disabled="partsStatus && editParams.equipmentModelId!==0"  style="width:300px">-->
                            <Option v-for="(partsModel,key) in partsModelArray" :value="partsModel.id" :key="key">{{ partsModel.name }}</Option>-->
                        </Select>
                       <a href="javascript:" v-if="!partsStatus" class="add" @click="partsModelVisible = true"><Icon custom="icon-manage" style="margin-right: 4px"/>管理备件型号</a>
                    </li>
                    <li class="item">
                        <span class="label">生产厂家：</span>
                        <Select v-model="editParams.equipmentManufacturerId" :disabled="partsStatus && editParams.equipmentManufacturerId !==0" style="width:300px">
                            <Option v-for="(manufacturer,key) in manufacturerArray" :value="manufacturer.id" :key="key">{{ manufacturer.name }}</Option>
                        </Select>
                        <a href="javascript:" v-if="!partsStatus" class="add" @click="manufacturerVisible = true"><Icon custom="icon-manage" style="margin-right: 4px"/>管理生产厂家</a>
                    </li>
                    <li class="item">
                        <span class="label">存放地点：</span>
                        <Select v-model="editParams.equipmentWarehouseId" :disabled="partsStatus && editParams.equipmentWarehouseId!==0" style="width:300px">
                            <Option v-for="(location,key) in locationArray" :value="location.id" :key="key">{{ location.name }}</Option>
                        </Select>
                        <a href="javascript:" v-if="!partsStatus" class="add" @click="locationVisible = true"><Icon custom="icon-manage" style="margin-right: 4px"/>管理存放地点</a>
                    </li>
                    <li class="item">
                        <span class="label">计算单位：</span>
                        <Select v-model="editParams.unit" :disabled="partsStatus && editParams.unit!==''" filterable allow-create @on-create="handleCreate" style="width:300px">
                            <Option v-for="(unit,key) in inventoryUnitType" :value="unit.unitType" :key="key">{{ unit.unitType }}</Option>
                        </Select>
                    </li>
                    <li class="item">
                        <span class="label">安装位置：</span>
                        <div class="location-edit-box">
                            <div class="box" :class="focusIndex === key?'focus':''" :key="key" v-for="(item,key) in editParams.positions">
                                <span class="position">位置{{ key+1 }}</span>
                                <input v-model="editParams.positions[key]" :disabled="key+1<=editParams.positionsLength" placeholder="输入位置" @focus="focusIndex = key" @blur="focusIndex = -1" class="text-input"/>
                                <a href="javascript:" class="close" v-if="!partsStatus" @click="onLocationClose(key)"><Icon type="ios-close-circle" size="16"/></a>
                            </div>
                            <a href="javascript:" class="location-add" @click="onAddLocation"><Icon type="md-add" size="18"/>添加位置</a>
                        </div>
                    </li>
                    <li class="item">
                        <span class="label">备件图片：</span>
                            <div class="device-upload">
                                <a href="javascript:" class="btn" v-if="!speedSingleVisible && editParams.fileUrl===''">
                                    <Icon type="ios-add" class="icon"/>
                                    上传图片
                                </a>
                                <div class="progress" v-if="speedSingleVisible">
                                    <Progress :percent="complete" />
                                </div>
                                <input type="file" ref="pathClear" accept="image/*" v-if="!speedSingleVisible" class="file" @change="onFileChange($event)">
                                <div class="file-image" v-if="editParams.fileUrl!==''">
                                    <img :src="editParams.fileUrl" class="image">
                                    <div class="handle">
                                        <div class="box">
<!--                                            <a href="javascript:" @click="onImageAmplify(deviceInfoObj.name,newlyParams.filesUrl,newlyParams.files)"><Icon custom="look-big" :size="25"/></a>-->
                                            <a href="javascript:" @click="onClearImage()"><Icon type="ios-trash-outline" :size="25"/></a>
                                        </div>
                                    </div>
                              </div>
                        </div>
                    </li>
                    <li class="item layout-location-btn">
                        <Button @click="onCancel">取消</Button>
                        <Button type="primary" :disabled="speedSingleVisible" :loading="submitLoading" @click="onAddInventoryCheck">保存</Button>
                    </li>
              </ul>
            </div>
        </Modal>
        <!--e: 编辑列表-->
        <!--s: Modal 管理备件型号-->
        <Modal
            v-model="partsModelVisible"
            title="管理备件型号"
            width="580"
            :loading="submitLoading"
            @on-visible-change="onModelVisibleChange"
            footer-hide>
            <div class="inventory-modal-info-box">

                <div class="device-modal-title">
                    <div class="modal-search">
                        <Icon type="ios-search" class="search" size="20"></Icon>
                        <Input v-model="partsModelValue" @on-keyup="onDeviceModalSearch" placeholder="输入备件型号" style="width: 300px"></Input>
                    </div>
                    <div class="modal-btn">
                        <Button @click="onDeviceModalResetting">重置</Button>
                        <Button type="primary" @click="onDeviceModalSearch">搜索</Button>
                    </div>
                </div>

                <div class="device-modal-list" id="deviceList">
                    <ul>
                        <li class="modal-hover" :key="key" v-for="(deviceModel,key) in partsModelSelect">
                            <div class="modal-text" v-if="deviceModel.visible">
                                <div class="text">{{ deviceModel.name }}</div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceModalEdit(key)"><Icon type="md-create" /></a>
                                    <a href="javascript:" @click="onDeviceModalDel(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                            <div class="modal-add-li" v-if="!deviceModel.visible">
                                <div class="modal-add">
                                    <Input v-model="deviceModelInfo" placeholder="输入备件型号" show-word-limit maxlength="25" style="width: 402px"></Input>
                                </div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceModelEditCheck(key)"><Icon type="ios-checkmark-circle-outline" /></a>
                                    <a href="javascript:" @click="onDeviceModalClose(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                        </li>
                        <li class="modal-add-li" v-if="deviceAddVisible">
                            <div class="modal-add">
                              <Input v-model="partsEditName" placeholder="输入设备型号" show-word-limit maxlength="25" style="width: 402px"></Input>
                            </div>
                            <div class="btn">
                                <a href="javascript:" @click="onDeviceModelCheck"><Icon type="ios-checkmark-circle-outline" /></a>
                                <a href="javascript:" @click="deviceAddVisible = false;partsEditName = ''"><Icon type="ios-close-circle-outline" /></a>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="partsModelSelect.length === 0">未找到您要搜索的数据</div>
                </div>

                <div class="device-modal-btn">
                    <Button type="primary" icon="ios-add" :disabled="partsBtnVisible" ghost @click="onPartsAddModel">新增</Button>
                </div>

            </div>
        </Modal>
        <!--e: Modal 管理备件型号-->
        <!--s: Modal 新增生产厂家-->
        <Modal
            v-model="manufacturerVisible"
            title="管理生产厂家"
            width="580"
            :loading="submitLoading"
            @on-visible-change="onFactureVisibleChange"
            footer-hide>
            <!--            <div class="device-modal">-->
            <!--                <span class="label">生产厂家：</span>-->
            <!--                <Input v-model="manufacturerParams.manufacturerName" type="textarea" maxlength="25" show-word-limit placeholder="请输入" style="width: 300px" />-->
            <!--            </div>-->
            <!--            <div class="device-footer">-->
            <!--                <Button @click="manufacturerVisible = false;manufacturerParams.manufacturerName = ''">取 消</Button>-->
            <!--                <Button type="primary" :loading="submitLoading" @click="onManufacturerCheck">确 定</Button>-->
            <!--            </div>-->
            <div class="inventory-modal-info-box">

                <div class="device-modal-title">
                    <div class="modal-search">
                        <Icon type="ios-search" class="search" size="20"></Icon>
                        <Input v-model="deviceFactureValue" @on-keyup="onDeviceFactureSearch" placeholder="输入生产厂家" style="width: 300px"></Input>
                    </div>
                    <div class="modal-btn">
                        <Button @click="onDeviceFactureResetting">重置</Button>
                        <Button type="primary" @click="onDeviceFactureSearch">搜索</Button>
                    </div>
                </div>

                <div class="device-modal-list" id="deviceFactureList">
                    <ul>
                        <li class="modal-hover" :key="key" v-for="(deviceFacture,key) in deviceFactureSelect">
                            <div class="modal-text" v-if="deviceFacture.visible">
                                <div class="text">{{ deviceFacture.name }}</div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceFactureEdit(key)"><Icon type="md-create" /></a>
                                    <a href="javascript:" @click="onDeviceFactureDel(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                            <div class="modal-add-li" v-if="!deviceFacture.visible">
                                <div class="modal-add">
                                    <Input v-model="deviceFactureInfo" placeholder="输入生产厂家" show-word-limit maxlength="25" style="width: 402px"></Input>
                                </div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceFactureEditCheck(key)"><Icon type="ios-checkmark-circle-outline" /></a>
                                    <a href="javascript:" @click="onDeviceFactureClose(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                        </li>
                        <li class="modal-add-li" v-if="deviceAddVisible">
                            <div class="modal-add">
                                <Input v-model="manufacturerParams.name" placeholder="输入生产厂家" show-word-limit maxlength="25" style="width: 402px"></Input>
                            </div>
                            <div class="btn">
                                <a href="javascript:" @click="onDeviceFactureCheck"><Icon type="ios-checkmark-circle-outline" /></a>
                                <a href="javascript:" @click="deviceAddVisible = false;manufacturerParams.name = ''"><Icon type="ios-close-circle-outline" /></a>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="deviceFactureSelect.length === 0">未找到您要搜索的数据</div>
                </div>

                <div class="device-modal-btn">
                    <Button type="primary" icon="ios-add" :disabled="deviceBtnVisible" ghost @click="onDeviceAddFacture">新增</Button>
                </div>

            </div>

        </Modal>
        <!--e: Modal 新增生产厂家-->
        <!--s: Modal 管理存放地点-->
        <Modal
            v-model="locationVisible"
            title="管理存放地点"
            width="580"
            :loading="submitLoading"
            @on-visible-change="onFactureVisibleChange"
            footer-hide>
            <!--            <div class="device-modal">-->
            <!--                <span class="label">生产厂家：</span>-->
            <!--                <Input v-model="manufacturerParams.manufacturerName" type="textarea" maxlength="25" show-word-limit placeholder="请输入" style="width: 300px" />-->
            <!--            </div>-->
            <!--            <div class="device-footer">-->
            <!--                <Button @click="manufacturerVisible = false;manufacturerParams.manufacturerName = ''">取 消</Button>-->
            <!--                <Button type="primary" :loading="submitLoading" @click="onManufacturerCheck">确 定</Button>-->
            <!--            </div>-->
            <div class="inventory-modal-info-box">

                <div class="device-modal-title">
                    <div class="modal-search">
                        <Icon type="ios-search" class="search" size="20"></Icon>
                        <Input v-model="deviceLocationValue" @on-keyup="onDeviceLocationSearch" placeholder="输入存放地点" style="width: 300px"></Input>
                    </div>
                    <div class="modal-btn">
                        <Button @click="onDeviceLocationResetting">重置</Button>
                        <Button type="primary" @click="onDeviceLocationSearch">搜索</Button>
                    </div>
                </div>

                <div class="device-modal-list" id="deviceLocationList">
                    <ul>
                        <li class="modal-hover" :key="key" v-for="(location,key) in locationSelectArray">
                            <div class="modal-text" v-if="location.visible">
                                <div class="text">{{ location.name }}</div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceLocationEdit(key)"><Icon type="md-create" /></a>
                                    <a href="javascript:" @click="onDeviceLocationDel(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                            <div class="modal-add-li" v-if="!location.visible">
                                <div class="modal-add">
                                    <Input v-model="deviceLocationInfo" placeholder="输入存放地点" show-word-limit maxlength="25" style="width: 402px"></Input>
                                </div>
                                <div class="btn">
                                    <a href="javascript:" @click="onDeviceLocationEditCheck(key)"><Icon type="ios-checkmark-circle-outline" /></a>
                                    <a href="javascript:" @click="onDeviceLocationClose(key)"><Icon type="ios-close-circle-outline" /></a>
                                </div>
                            </div>
                        </li>
                        <li class="modal-add-li" v-if="deviceLocationAddVisible">
                            <div class="modal-add">
                                <Input v-model="locationParams.name" placeholder="输入存放地点" show-word-limit maxlength="25" style="width: 402px"></Input>
                            </div>
                            <div class="btn">
                                <a href="javascript:" @click="onDeviceLocationCheck"><Icon type="ios-checkmark-circle-outline" /></a>
                                <a href="javascript:" @click="deviceLocationAddVisible = false;locationParams.name = ''"><Icon type="ios-close-circle-outline" /></a>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="locationSelectArray.length === 0">未找到您要搜索的数据</div>
                </div>

                <div class="device-modal-btn">
                    <Button type="primary" icon="ios-add" :disabled="deviceLocationBtnVisible" ghost @click="onDeviceAddLocation">新增</Button>
                </div>

            </div>

        </Modal>
        <!--e: Modal 新增生产厂家-->
        <!--s: Modal 入库-->
        <Modal
            v-model="warehousingVisible"
            title="入库记录"
            width="1220"
            :loading="partsModalLoading"
            @on-visible-change="onWarehousingVisibleChange"
            class-name="modal-record-box"
            footer-hide>
            <div class="record-box" @click="onPartsDownVisible">
                <div class="record-header">
                    <div class="box"><Icon custom="info-icon"></Icon>仔细检查入库数量，提交后不可更改</div>
                </div>
                <div class="record-content">
                    <div class="group-box" :key="'warehousing'+index" v-for="(warehousing,index) in warehousingArray">
                        <div class="group-header">
                            <div class="group-name">
                                <Icon type="ios-square" size="18" />
                                <div class="group-select-box">
                                    <div class="group-name-search" tabindex="0" @click.stop="onPartsDownVisibleUp(index) ">
                                        <span class="text"><font v-if="warehousing.name === ''">选择设备</font>{{ warehousing.name !== ''?warehousing.name:'' }}</span>
                                        <Icon :type="warehousingArray[index].visible?'ios-arrow-up':'ios-arrow-down'" size="16"/>
                                    </div>
                                    <div class="group-select-down" v-if="warehousingArray[index].visible" @click.stop>
                                        <div class="box">
                                            <Input v-model="partsAllSelectValue" prefix="ios-search-outline" @on-keyup="onPartsAllSearch" placeholder="备件名称、备件型号、生产厂家"/>
                                            <ul>
                                                <li :class="warehousing.sparePartsId === partsAll.id?'active':''" :key="key" v-for="(partsAll,key) in partsAllSelectArray" @click.stop="onWarehousingSelect(partsAll,index)">
                                                    <p class="title">{{ partsAll.name }}</p>
                                                    <p class="text">备件型号：{{ partsAll.equipmentModelName || '无'}}</p>
                                                    <p class="text">生产厂家：{{ partsAll.equipmentManufacturerName || '无'}}</p>
                                                    <p class="text">存放地点：{{ partsAll.equipmentWarehouseName || '无'}}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="group-btn">
                                <Poptip
                                    confirm
                                    @click.native.stop
                                    title="确认删除这条记录吗?"
                                    placement="top-end"
                                    @on-ok="onDeleteWarehousing(index)">
                                    <a href="javascript:"><Icon type="ios-trash" :size="22"/>删除</a>
                                </Poptip>
                            </div>
                        </div>
                        <div class="group-table" v-if="warehousing.sparePartsId!==''">
                            <Table ref="selection" border :columns="warehousingColumns" :data="[warehousing]" >
                                <template slot-scope="{ row }" slot="存放地点">
                                    <Input v-if="row.equipmentWarehouseName !== ''" v-model="row.equipmentWarehouseName" disabled/>
                                    {{ row.equipmentWarehouseName === ''?'无':'' }}
                                </template>
                                <template slot="入库数量">
                                    <InputNumber v-model="warehousing.num" :min="1" controls-outside style="width: 100%;" />
                                </template>
                                <template slot-scope="{ row }" slot="单位">
                                    <Input v-if="row.unit !== ''" v-model="row.unit" disabled/>
                                    {{ row.unit===''?'无':'' }}
                                </template>
                                <template  slot="记录说明">
                                    <Input v-model="warehousing.describes" :maxlength="50" show-word-limit :maxRows="2" type="textarea" style="width:100%;margin:5px 0;"/>
                                </template>
                            </Table>
                        </div>
                    </div>
                    <div class="group-add">
                        <a href="javascript:" @click="onAddRecord"><Icon type="ios-add" size="16"></Icon>添加记录</a>
                    </div>
                    <div class="group-btn-box">
                        <Button @click="onWarehousingCancel">取消</Button>
                        <Button type="primary" :loading="warehousingSubLoading" @click="onWarehousingSubmit">提交</Button>
                    </div>
                </div>
            </div>
        </Modal>
        <!--e: Modal 入库-->
        <!--s: Modal 出库-->
        <Modal
            v-model="outboundVisible"
            title="出库记录"
            width="1220"
            :loading="partsModalLoading"
            @on-visible-change="onOutboundVisibleChange"
            class-name="modal-record-box"
            footer-hide>
            <div class="record-box" @click="onPartsOutboundDownVisible">
                <div class="record-content">
                    <div class="group-box" :key="'outbound'+index" v-for="(outbound,index) in outboundArray">
                        <div class="group-header">
                            <div class="group-name">
                                <Icon type="ios-square" size="18" />
                                <div class="group-select-box">
                                    <div class="group-name-search" tabindex="0" @click.stop="onPartsOutboundDownVisibleUp(index) ">
                                        <span class="text"><font v-if="outbound.name === ''">选择备件</font>{{ outbound.name !== ''?outbound.name:'' }}</span>
                                        <Icon :type="outboundArray[index].visible?'ios-arrow-up':'ios-arrow-down'" size="16"/>
                                    </div>
                                    <div class="group-select-down" v-if="outboundArray[index].visible" @click.stop>
                                        <div class="box">
                                            <Input v-model="partsAllSelectValue" prefix="ios-search-outline" @on-keyup="onPartsAllSearch" placeholder="备件名称、备件型号、生产厂家"/>
                                            <ul>
                                                <li :class="outbound.sparePartsId === partsAll.id?'active':''" :key="key" v-for="(partsAll,key) in partsAllSelectArray" @click.stop="onOutboundSelect(partsAll,index)">
                                                    <p class="title">{{ partsAll.name }}</p>
                                                    <p class="text">备件型号：{{ partsAll.equipmentModelName || '无'}}</p>
                                                    <p class="text">生产厂家：{{ partsAll.equipmentManufacturerName || '无'}}</p>
                                                    <p class="text">存放地点：{{ partsAll.equipmentWarehouseName || '无'}}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="group-btn">
                                <Poptip
                                    confirm
                                    @click.native.stop
                                    title="确认删除这条记录吗?"
                                    placement="top-end"
                                    @on-ok="onDeleteOutbound(index)">
                                    <a href="javascript:"><Icon type="ios-trash" :size="22"/>删除</a>
                                </Poptip>
                            </div>
                        </div>
                        <div class="group-table" v-if="outbound.sparePartsId!==''">
                            <Table ref="selection" border :columns="outboundColumns" :data="[outbound]" >
                                <template slot="检修日期">
                                    <DatePicker v-model="outboundArray[index].repairDate" @on-change="onDateChange($event,index)" type="date" placeholder="请选择" style="width: 100%" />
                                </template>
                                <template slot="检修位置">
                                    <Select v-if="outboundArray[index].repairPosition !==''" v-model="outboundArray[index].repairPosition" style="width: 100%">
                                        <Option v-for="(positions,key) in outbound.positions" :value="positions" :key="key">{{ positions }}</Option>
                                    </Select>
                                    {{ outboundArray[index].repairPosition === ''?'无':'' }}
                                </template>
                                <template slot="检修部门">
                                    <Cascader :modal-value="outboundArray[index].deptId" :data="departmentList" @on-change="onCascader($event,index)" :clearable="false" change-on-select style="width:100%" />
                                </template>
                                <template slot="检修人">
                                    <Select v-model="outboundArray[index].userIdList" multiple style="width: 100%">
                                        <Option v-for="(account,key) in accountListArray" :value="account.id" :key="key">{{ account.name }}</Option>
                                    </Select>
                                </template>
                                <template slot="更换数量">
                                    <InputNumber v-model="outboundArray[index].num" :min="1" controls-outside style="width: 100%;" />
                                </template>
                                <template slot="单位">
                                    <Input v-if="outboundArray[index].unit!==''" v-model="outboundArray[index].unit" disabled/>
                                    {{ outboundArray[index].unit === ''?'无':'' }}
                                </template>
                                <template  slot="记录说明">
                                    <Input v-model="outboundArray[index].describes" :maxlength="50" show-word-limit :maxRows="2" type="textarea" style="width:100%;margin:5px 0;"/>
                                </template>
                            </Table>
                        </div>
                    </div>
                    <div class="group-add">
                        <a href="javascript:" @click="onAddOutboundRecord"><Icon type="ios-add" size="16"></Icon>添加记录</a>
                    </div>
                    <div class="group-btn-box">
                        <Button @click="onOutboundCancel">取消</Button>
                        <Button type="primary" :loading="warehousingSubLoading" @click="onOutboundSubmit">提交</Button>
                    </div>
                </div>
            </div>
        </Modal>
        <!--e: Modal 出库-->
        <!--s: Modal 编辑入库记录-->
        <Modal
            v-model="warehousingRecordVisible"
            title="入库记录"
            width="500"
            footer-hide>
            <div class="inventory-edit-box">
                <ul>
                    <li class="item" style="margin-bottom: 5px">
                        <span class="edit-title">{{ warehousingRecord.sparePartsName }}</span>
                    </li>
                    <li class="item" style="margin-bottom: 5px">
                        <div class="edit-info">
                          <p class="text">设备型号：{{ warehousingRecord.spareModelName || '无'}}</p>
                          <p class="text">生产厂家：{{ warehousingRecord.spareManufacturerName || '无'}}</p>
                          <p class="text">存放地点：{{ warehousingRecord.spareWarehouseName || '无'}}</p>
                        </div>
                    </li>
                    <li class="item" style="margin-bottom: 5px" v-if="JSON.stringify(warehousingRecord) !=='{}'">
                        <span class="label">填报日期：</span>
                        <div class="edit-text">{{ warehousingRecord.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;填报人：{{ warehousingRecord.createUser }}</div>
                    </li>
<!--                    <li class="item" >-->
<!--                        <span class="label">存放地点：</span>-->
<!--                        <Input v-model="warehousingRecord.spareWarehouseName" disabled style="width: 300px" />-->
<!--                    </li>-->
                    <li class="item">
                        <span class="label">入库数量：</span>
                        <Input v-model="warehousingRecord.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ warehousingRecord.unit }}
                    </li>
                    <li class="item edit-input">
                        <span class="label">入库说明：</span>
                        <Input v-model="warehousingRecord.describes" :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                    <li class="item edit-btn">
                        <Button @click="warehousingRecordVisible = false">取消</Button>
                        <Button type="primary" :loading="submitLoading" @click="onAddWarehousingRecordCheck">提交</Button>
                    </li>
                </ul>
            </div>
        </Modal>
        <!--s: Modal 编辑记录-->
        <!--s: Modal 编辑出库记录-->
        <Modal
            v-model="outboundRecordVisible"
            title="出库记录"
            width="500"
            footer-hide>
            <div class="inventory-edit-box">
                <ul>
                    <li class="item" style="margin-bottom: 5px">
                        <span class="edit-title">{{ outboundRecord.sparePartsName }}</span>
                    </li>
                    <li class="item" style="margin-bottom: 5px">
                        <div class="edit-info">
                            <p class="text">设备型号：{{ outboundRecord.spareModelName || '无' }}</p>
                            <p class="text">生产厂家：{{ outboundRecord.spareManufacturerName || '无' }}</p>
                            <p class="text">存放地点：{{ outboundRecord.spareWarehouseName || '无'}}</p>
                        </div>
                    </li>
                    <li class="item" style="margin-bottom: 5px" v-if="JSON.stringify(outboundRecord) !=='{}'">
                        <span class="label">填报日期：</span>
                        <div class="edit-text">{{ outboundRecord.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;填报人：{{ outboundRecord.createUser }}</div>
                    </li>
                    <li class="item">
                        <span class="label">检修位置：</span>
                        <Select v-model="outboundRecord.repairPosition" style="width: 300px">
                            <Option v-for="(positions,key) in outboundRecord.positions" :value="positions" :key="key">{{ positions }}</Option>
                        </Select>
                    </li>
                    <li class="item">
                        <span class="label required">检修部门：</span>
                        <Cascader :data="departmentList" v-model="outboundRecord.nodeIdList" @on-change="onRecordCascader" :clearable="false" change-on-select style="width: 300px" />
                    </li>
                    <li class="item">
                        <span class="label required">检修人：</span>
                        <Select v-model="outboundRecord.userIdList" multiple style="width: 300px">
                            <Option v-for="(account,key) in accountListArray" :value="account.id" :key="key">{{ account.name }}</Option>
                        </Select>
                    </li>
                    <li class="item">
                        <span class="label required">检修日期：</span>
                        <DatePicker v-model="outboundRecord.repairDate" @on-change="onDateRecordChange" type="date" placeholder="请选择" style="width: 300px" />
                    </li>
                    <li class="item">
                        <span class="label">更换数量：</span>
                        <Input v-model="outboundRecord.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ outboundRecord.unit === '无'?'': outboundRecord.unit}}
                    </li>
                    <li class="item edit-input">
                        <span class="label">检修说明：</span>
                        <Input v-model="outboundRecord.describes" :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                    <li class="item edit-btn">
                        <Button @click="outboundRecordVisible = false">取消</Button>
                        <Button type="primary" :loading="submitLoading" @click="onAddOutboundRecordCheck">提交</Button>
                    </li>
                </ul>
            </div>
        </Modal>
        <!--s: Modal 编辑出库记录-->
        <!--s: Modal 编辑记录-->
        <Modal
            v-model="lookPartsVisible"
            :title="lookPartsArray.operationType === 1?'入库记录':'出库记录'"
            width="500"
            footer-hide>
            <div class="inventory-edit-box">
                <span class="edit-void" v-if="lookPartsArray.operationType!==1 && lookPartsArray.status === 1"></span>
                <ul>
                    <li class="item" style="margin-bottom: 5px">
                        <span class="edit-title">{{ lookPartsArray.sparePartsName }}</span>
                    </li>
                    <li class="item" style="margin-bottom: 5px">
                        <div class="edit-info">
                            <p class="text">设备型号：{{ lookPartsArray.spareModelName || '无'}}</p>
                            <p class="text">生产厂家：{{ lookPartsArray.spareManufacturerName || '无'}}</p>
                            <p class="text">存放地点：{{ lookPartsArray.spareWarehouseName || '无'}}</p>
                        </div>
                    </li>
                    <li class="item" style="margin-bottom: 5px" v-if="JSON.stringify(lookPartsArray) !=='{}'">
                        <span class="label">填报日期：</span>
                        <div class="edit-text">{{ lookPartsArray.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;填报人：{{ lookPartsArray.createUser }}</div>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修位置：</span>
                        <Input v-if="lookPartsArray.repairPosition!==''" v-model="lookPartsArray.repairPosition" disabled style="width: 300px" />
                        <div class="edit-text" v-if="lookPartsArray.repairPosition === ''">无</div>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修部门：</span>
                        <Input v-model="lookPartsArray.deptName" disabled style="width: 300px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修人：</span>
                        <p style="width:300px;line-height: 32px"><font :key="key" v-for="(item,key) in lookPartsArray.userNameList">{{ item }}{{ key!==0 && key!== lookPartsArray.userNameList.length - 1?',':''}}</font></p>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修日期：</span>
                        <Input v-model="lookPartsArray.repairDate" disabled style="width: 300px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">更换数量：</span>
                        <Input v-model="lookPartsArray.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ lookPartsArray.unit === '无'?'': lookPartsArray.unit}}
                    </li>
                    <li class="item edit-input" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修说明：</span>
                        <Input v-model="lookPartsArray.describes" disabled :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 1">
                        <span class="label">存放地点：</span>
                        <Input v-if="lookPartsArray.spareWarehouseName !== ''" v-model="lookPartsArray.spareWarehouseName" disabled style="width: 300px" />
                        <div class="edit-text" v-if="lookPartsArray.spareWarehouseName === ''">无</div>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 1">
                        <span class="label">入库数量：</span>
                        <Input v-model="lookPartsArray.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ lookPartsArray.unit === '无'?'': lookPartsArray.unit}}
                    </li>
                    <li class="item edit-input" v-if="lookPartsArray.operationType === 1">
                        <span class="label">入库说明：</span>
                        <Input v-model="lookPartsArray.describes" disabled :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                </ul>
            </div>
        </Modal>
        <!--s: Modal 编辑记录-->
    </div>
</template>

<script>
import DeviceInfo from './inventory'
export default DeviceInfo
</script>
<style lang="less">
@import "inventory";
</style>
